import type { RankingEntry } from '@db/types/UserGameStats';

export const dummyRankingData: RankingEntry[] = [
  {
    user_id: 'dummy-1',
    user_name: '...',
    rank: 1,
    high_score: 0,
  },
  {
    user_id: 'dummy-2',
    user_name: '...',
    rank: 2,
    high_score: 0,
  },
  {
    user_id: 'dummy-3',
    user_name: '...',
    rank: 3,
    high_score: 0,
  },
  {
    user_id: 'dummy-4',
    user_name: '...',
    rank: 4,
    high_score: 0,
  },
  {
    user_id: 'dummy-5',
    user_name: '...',
    rank: 5,
    high_score: 0,
  },
];
